import React from "react";

import SVG from "@/assets/svg";

type DatePickerIconProps = React.ComponentProps<typeof SVG.Date> & {
  ownerState?: unknown;
};

const DatePickerIcon = ({ ownerState, ...props }: DatePickerIconProps) => {
  void ownerState;
  return <SVG.Date {...props} />;
};

export default DatePickerIcon;
